<script setup lang="ts">
import BaseButton from "@/components/ui/BaseButton/BaseButton.vue";

defineProps<{ disabled?: boolean; label?: string }>();
</script>

<template>
  <BaseButton variant="ghost" color="grey" size="small" class="menu-list-footer" :disabled>
    {{ label ?? $t("general.clear") }}
  </BaseButton>
</template>

<style lang="scss" scoped>
@use "@/styles/font";
@use "@/styles/variables/colors";

.menu-list-footer.menu-list-footer {
  flex-shrink: 0;
  font-weight: font.$weight-medium !important; // BaseButton overrides font-weight
  border-top: 1px solid colors.$border-light;
  border-radius: 0;
  height: 32px !important;
  outline: revert;
}
</style>
